module.exports = __webpack_public_path__ + "img/flavor_grape.2a63d472.png";